if (!customElements.get('uk-header-catalog')) {
  customElements.define('uk-header-catalog', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.selectionObserver?.disconnect();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.desktop = this.dataset.layout === 'desktop';
      this.outer = this.closest('details');
      this.menu = this.closest('lb-gold-menu');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          const forward = this.desktop ? 'ArrowDown' : 'ArrowRight';
          const backward = this.desktop ? 'ArrowUp' : 'ArrowLeft';
          let next;
          if (event.key === forward) next = (index + 1) % this.tabs.length;
          if (event.key === backward) next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus({preventScroll: true});
          if (!this.desktop) this.tabs[next].scrollIntoView({block: 'nearest', inline: 'nearest'});
        }, options);
      });
      if (this.desktop && this.outer) {
        this.selectionObserver = new MutationObserver(() => this.syncFromMenu());
        this.selectionObserver.observe(this.outer, {attributes: true, attributeFilter: ['data-category']});
      }
      this.outer?.addEventListener('toggle', () => this.updateHeight(), options);
      window.addEventListener('resize', () => this.updateHeight(), options);
      window.addEventListener('scroll', () => {
        if (this.outer?.open) this.updateHeight();
      }, {...options, passive: true});
      document.addEventListener('shopify:block:select', event => {
        if (this.desktop !== (innerWidth >= 1150)) return;
        const index = this.tabs.findIndex(tab => tab.dataset.catalogBlock === event.detail?.blockId);
        const service = [...this.querySelectorAll('[data-catalog-service]')].find(element => element.dataset.catalogService === event.detail?.blockId);
        if (index < 0 && !service) return;
        if (this.desktop) {
          this.menu?.setOpen(this.outer, true);
        } else {
          this.outer.open = true;
          document.getElementById('header-sidebar-menu')?.show?.();
        }
        if (index >= 0) this.select(index);
        this.updateHeight();
        (service || this.tabs[index])?.scrollIntoView({block: 'nearest', inline: 'nearest'});
      }, options);
      if (this.desktop && window.ResizeObserver) {
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => this.updateHeight());
        this.observer.observe(this.closest('.header__wrapper'));
      }
      const initial = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
      if (this.desktop) {
        this.syncTabs(initial);
        this.syncFromMenu();
      } else {
        this.select(initial);
      }
      this.updateHeight();
    }
    syncTabs(index) {
      this.tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
    }
    syncFromMenu() {
      const index = this.tabs.findIndex(tab => tab.closest('[data-us-category]')?.dataset.category === this.outer?.dataset.category);
      if (index >= 0) this.syncTabs(index);
    }
    select(index) {
      if (!this.tabs[index]) return;
      this.syncTabs(index);
      if (this.desktop) {
        if (this.outer?.open) this.menu?.selectCategory(this.outer, this.tabs[index].closest('[data-us-category]').dataset.category);
        return;
      }
      const target = this.tabs[index].getAttribute('aria-controls');
      this.panels.forEach(panel => {
        const selected = panel.id === target;
        panel.hidden = !selected;
        panel.inert = !selected;
      });
    }
    updateHeight() {
      if (!this.desktop) return;
      const panel = this.closest('.lb-gm-panel');
      const header = this.closest('.header__wrapper');
      if (!panel || !header) return;
      const available = Math.max(0, innerHeight - header.getBoundingClientRect().bottom - 12);
      panel.style.setProperty('--uk-catalog-available', `${available}px`);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.selectionObserver?.disconnect();
    }
  });
}
